import React from 'react';
import B2BSignupWizard from '../B2B/B2BSignupWizard';

const ValetServiceSignup = () => (
  <B2BSignupWizard
    profileTitle="Valet Service Provider Profile"
    sendOtpPath="/valet-service/signup/send-email-otp"
    verifyOtpPath="/valet-service/signup/verify-email-otp"
    submitPath="/valet-service/signup"
    loginPath="/associates-login"
    backPath="/signup-as"
    isValetService
  />
);

export default ValetServiceSignup;
